import { render, staticRenderFns } from "./CtcAffilizzStep.vue?vue&type=template&id=373a891e&scoped=true&"
import script from "./CtcAffilizzStep.vue?vue&type=script&lang=js&"
export * from "./CtcAffilizzStep.vue?vue&type=script&lang=js&"
import style0 from "./CtcAffilizzStep.vue?vue&type=style&index=0&id=373a891e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a891e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
